import { action } from 'src/store/actions';

export const FETCH_SHIPPING_COST_TABLE = 'FETCH_SHIPPING_COST_TABLE';
export const REQUEST_SHIPPING_COST_TABLE = 'REQUEST_SHIPPING_COST_TABLE';
export const SUCCESS_SHIPPING_COST_TABLE = 'SUCCESS_SHIPPING_COST_TABLE';
export const FAILURE_SHIPPING_COST_TABLE = 'FAILURE_SHIPPING_COST_TABLE';

export const fetchShippingCostTable = () => action(FETCH_SHIPPING_COST_TABLE);
export const requestShippingCostTable = () => action(REQUEST_SHIPPING_COST_TABLE);
export const requestShippingCostTableSuccess = (response: any) => action(SUCCESS_SHIPPING_COST_TABLE, { response });
export const requestShippingCostTableFailure = (error: any) => action(FAILURE_SHIPPING_COST_TABLE, { error });
